export default "__VITE_ASSET__DXMaG9Bf__"